import { useSelector } from "react-redux";
import { State } from "../../app/store";
import { isEmbeddedFrame } from "../../utils/isEmbeddedFrame";

/**
 * Sklep w ramce na stronie klienta z włączonym „Ukryj nawigację w trybie iframe”.
 * B2B zostaje przy swojej nawigacji, bo jego linki nie istnieją po stronie klienta.
 */
const useEmbedMode = () => {
  const hideNavigationInIframe = useSelector((state: State) => state.config.configuration.hideNavigationInIframe);
  const isB2B = useSelector((state: State) => Boolean(state.auth.userData.b2bType));

  return Boolean(hideNavigationInIframe) && !isB2B && isEmbeddedFrame();
};

export default useEmbedMode;
